import {
  SearchQueryStringParams,
  SearchType,
  getHasSearchQueryParams,
} from 'components/search/utils';
import { useQueryStringParams } from 'hooks/useQueryStringParams';

/**
 * Looks at the current query string params and returns a boolean if
 * it has the search query string according to the search types of togo, city
 * or group
 */
export function useHasSearchQueryStringParams(type: SearchType): boolean {
  const queryStringParams = useQueryStringParams<SearchQueryStringParams>();
  return getHasSearchQueryParams(type, queryStringParams);
}
